// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectWindowTypeQueryResult, selectWindowTypesPageLoading, selectWindowTypesShowInitWaitingMessage} from '../_selectors/window-type.selectors';

export class WindowTypesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectWindowTypesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectWindowTypesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectWindowTypeQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
